/** @format */

import React, { useState, useEffect } from "react";
import { projectStorage } from "components/ProjectStorage";

const AlgorithmTab = ({ outputJson }) => {
  const [getUrl, setGetUrl] = useState();
  const [method, setMethod] = useState();
  const [score, setScore] = useState();
  const [feature, setFeature] = useState();
  const [using, setUsing] = useState();
  const [target, setTarget] = useState([]);
  // const [preprocessInfo, setPreprocessInfo] = useState();
  // const [suggestionSpeed, setSuggestionSpeed] = useState();
  // const [suggestionStart, setSuggestionStart] = useState();
  // const [suggestionEnd, setSuggestionEnd] = useState();

  /** 데이터 분석 목록 받아오기 */
  useEffect(async () => {
    if (outputJson) {
      const storageFileRef = projectStorage.ref(outputJson);
      storageFileRef
        .getDownloadURL()
        .then(function (url) {
          setGetUrl(url);
        })
        .catch(function (error) {
          // Handle any errors
          console.log("error : ", error);
        });
    }
  }, []);

  useEffect(async () => {
    if (getUrl) {
      const res = await fetch(getUrl);
      const algorithmData = await res.json();
      /** json 파일 읽기 */
      const jsonResult = algorithmData.result;
      const jsonTarget = algorithmData.target;
      setMethod(jsonResult.Method);
      setScore(jsonResult.Score);
      setFeature(jsonResult.feature_importance);
      setUsing(jsonResult.using);
      setTarget(jsonTarget);
      // setPreprocessInfo(jsonResult.preprocessInfo);
      // setSuggestionSpeed(jsonResult.suggestionSpeed);
      // setSuggestionStart(jsonResult.suggestionStart);
      // setSuggestionEnd(jsonResult.suggestionEnd);
    }
  }, [getUrl]);

  // const handleFileDownload = () => {
  //   const fileNameSplit = outputJson.split("/");
  //   const lastFileName = fileNameSplit[fileNameSplit.length - 1];
  //   const fileName = lastFileName.split(".");

  //   const blob = new Object();
  //   blob.before = { shape: preprocessInfo.before.shape, count: preprocessInfo.before.count };
  //   blob.after = { shape: preprocessInfo.after.shape, count: preprocessInfo.after.count };
  //   blob.time = { start: preprocessInfo.start, end: preprocessInfo.end, time: preprocessInfo.time };
  //   blob.accuracy = preprocessInfo.accuracy;
  //   blob.suggestion = { speed: suggestionSpeed, start: suggestionStart, end: suggestionEnd };
  //   blob.score = score ? Number(score[Object.keys(score)]) * 100 : 0;

  //   var element = document.createElement("a");
  //   var newFile = new Blob([JSON.stringify(blob)], {
  //     type: "text/plain",
  //   });
  //   element.href = URL.createObjectURL(newFile);
  //   element.download = `preprocess_${fileName[0]}.txt`;

  //   document.body.appendChild(element);
  //   element.click();
  //   document.body.removeChild(element);
  // };

  if (!outputJson || !getUrl) return "";
  return (
    <div className="border-table">
      <div className="px-3">
        {/* <div className="text-lg font-bold text-555 py-3 px-4 bg-gray-input rounded-sm">{data.fileName}</div> */}
        <div className="row flex items-center">
          <div className="col-12 col-md-3 mt-3">
            <p className="mb-0 text-888 font-bold">학습유형</p>
          </div>
          <div className="col-12 col-md-9 mt-3">
            <div className="row px-3">
              <p className="font-bold text-333 py-2 px-3 bg-gray-input rounded-md mb-2.5">{method}</p>
            </div>
          </div>
        </div>
        <div className="row flex items-srart mt-3">
          <div className="col-12 col-md-3 mt-3">
            <p className="mb-0 text-888 font-bold">사용된 알고리즘</p>
          </div>
          <div className="col-12 col-md-9 mt-3">
            <div className="row px-3">
              {using
                ? using.map((m, index) => (
                    <p key={`${m}${index}`} className="font-bold text-333 py-2 px-3 bg-gray-input rounded-md mr-3 mb-2.5">
                      {m}
                    </p>
                  ))
                : ""}
            </div>
          </div>
        </div>
        <div className="row flex items-start mt-3">
          <div className="col-12 col-md-3 mt-3">
            <p className="mb-0 text-888 font-bold">타켓</p>
          </div>
          <div className="col-12 col-md-9 mt-3">
            <div className="row px-3">
              {target
                ? target.map((m) => (
                    <p key={m} className="font-bold text-333 py-2 px-3 bg-gray-input rounded-md mr-3 mb-2.5">
                      {m}
                    </p>
                  ))
                : ""}
            </div>
          </div>
        </div>
        <div className="row flex items-start mt-3">
          <div className="col-12 col-md-3 mt-3">
            <p className="mb-0 text-888 font-bold">학습에 영향을 준 특징들</p>
            <p className="mb-0 text-888 font-bold text-xs mt-1">( 중요한 특징 순서 )</p>
          </div>
          <div className="col-12 col-md-9 mt-3">
            {feature
              ? feature.map((m, index) => (
                  <div key={m} className="row px-3">
                    <div className="flex font-bold text-333 py-2 px-3 bg-gray-input rounded-md mr-3 mb-2.5">
                      <p className="mb-0 text-aaa font-bold mr-3 text-lg">{index + 1}</p>
                      <p className="mt-1 font-bold text-333 bg-gray-input rounded-md">{m}</p>
                    </div>
                  </div>
                ))
              : ""}
          </div>
        </div>
        {method === "regression" ? (
          <div className="row flex items-start mt-3">
            <div className="col-12 col-md-3 mt-4">
              <p className="mb-0 text-888 font-bold">모델 평가</p>
            </div>
            <div className="col-12 col-md-9 mt-3">
              <div className="row px-3">
                <p className="font-bold text-lg text-primary py-1 rounded-md">R2 : {score ? score.R2 : "0"} </p>
              </div>
              <div className="row px-3">
                <p className="font-bold text-lg text-primary py-1 rounded-md">MSE : {score ? score.MSE : "0"} </p>
              </div>
              <div className="row px-3">
                <p className="font-bold text-lg text-primary py-1 rounded-md">RMSE : {score ? score.RMSE : "0"} </p>
              </div>
              <div className="row px-3">
                <p className="font-bold text-lg text-primary py-1 rounded-md">MAE : {score ? score.MAE : "0"} </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="row flex items-center mt-3">
            <div className="col-12 col-md-3 mt-3">
              <p className="mb-0 text-888 font-bold">정확도</p>
            </div>
            <div className="col-12 col-md-9 mt-3">
              <div className="row px-3">
                <p className="font-bold text-lg text-primary py-1 rounded-md">{score ? Number(score[Object.keys(score)]) * 100 : "0"} %</p>
              </div>
            </div>
          </div>
        )}

        {/* 정부 과제 테스트 - 데이터 전처리 표시 */}
        {/* {suggestionSpeed ? (
          <div className="row flex items-center mt-3">
            <div className="col-12 col-md-3 mt-3">
              <p className="mb-0 text-888 font-bold">추천 속도</p>
            </div>
            <div className="col-12 col-md-9 mt-3">
              {suggestionStart ? (
                <div className="row flex items-center">
                  <div className="col-12 col-sm-4 col-lg-3">
                    <p className="mb-0 text-999 font-bold whitespace-nowrap">추천 시작 시각</p>
                  </div>
                  <div className="col-12 col-md-8 col-lg-9">
                    <div className="row px-3">
                      <p className="font-bold text-primary py-1 rounded-md mb-0">{suggestionStart}</p>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              {suggestionEnd ? (
                <div className="row flex items-center">
                  <div className="col-12 col-sm-4 col-lg-3">
                    <p className="mb-0 text-999 font-bold whitespace-nowrap">추천 완료 시각</p>
                  </div>
                  <div className="col-12 col-md-8 col-lg-9">
                    <div className="row px-3">
                      <p className="font-bold text-primary py-1 rounded-md mb-0">{suggestionEnd}</p>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              <div className="row px-3">
                <p className="font-bold text-lg text-primary py-1 rounded-md">{suggestionSpeed}</p>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {preprocessInfo ? (
          <div className="w-full border-t border-ddd py-1 mt-3">
            <p className="mb-0 text-999 font-bold mt-3">데이터 전처리</p>
            <div className="row flex items-center">
              <div className="col-12 col-md-3 mt-3">
                <p className="mb-0 text-888 font-bold">데이터 전처리 이전</p>
              </div>
              <div className="col-12 col-md-9 mt-3">
                <div className="row px-3">
                  <div className="font-bold mb-0 text-999 py-1 rounded-md">
                    {preprocessInfo ? (
                      <div>
                        <div className="row flex items-center">
                          <div className="col-12 col-sm-3 col-lg-2">
                            <p className="mb-0 text-999 font-bold whitespace-nowrap">shape</p>
                          </div>
                          <div className="col-12 col-md-9 col-lg-10">
                            <div className="row px-3">
                              <p className="font-bold text-primary py-1 rounded-md mb-0">{JSON.stringify(preprocessInfo.before.shape)}</p>
                            </div>
                          </div>
                        </div>
                        <div className="row flex items-center">
                          <div className="col-12 col-sm-3 col-lg-2">
                            <p className="mb-0 text-999 font-bold whitespace-nowrap">count</p>
                          </div>
                          <div className="col-12 col-md-9 col-lg-10">
                            <div className="row px-3" style={{ display: "inline-block", wordBreak: "break-word" }}>
                              <p className="font-bold text-primary py-1 rounded-md mb-0">{JSON.stringify(preprocessInfo.before.count)}</p>
                            </div>
                          </div>
                        </div>

                        <button>
                          <a href={preprocessInfo.before.file} download className="text-xs" style={{ textDecoration: "underline" }}>
                            before 파일 다운로드
                          </a>
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row flex items-center">
              <div className="col-12 col-md-3 mt-3">
                <p className="mb-0 text-888 font-bold">데이터 전처리 이후</p>
              </div>
              <div className="col-12 col-md-9 mt-3">
                <div className="row px-3 break-words">
                  <div className="font-bold mb-0 text-999 py-1 rounded-md break-words">
                    <div>
                      <div className="row flex items-center">
                        <div className="col-12 col-sm-3 col-lg-2">
                          <p className="mb-0 text-999 font-bold whitespace-nowrap">shape</p>
                        </div>
                        <div className="col-12 col-md-9 col-lg-10">
                          <div className="row px-3">
                            <p className="font-bold text-primary py-1 rounded-md mb-0">{JSON.stringify(preprocessInfo.after.shape)}</p>
                          </div>
                        </div>
                      </div>
                      <div className="row flex items-center">
                        <div className="col-12 col-sm-3 col-lg-2">
                          <p className="mb-0 text-999 font-bold whitespace-nowrap">count</p>
                        </div>
                        <div className="col-12 col-md-9 col-lg-10">
                          <div className="row px-3" style={{ display: "inline-block", wordBreak: "break-word" }}>
                            <p className="font-bold text-primary py-1 rounded-md mb-0">{JSON.stringify(preprocessInfo.after.count)}</p>
                          </div>
                        </div>
                      </div>

                      <button>
                        <a href={preprocessInfo.after.file} download className="text-xs " style={{ textDecoration: "underline" }}>
                          after 파일 다운로드
                        </a>
                      </button>
                
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row flex items-center">
              <div className="col-12 col-md-3 mt-3">
                <p className="mb-0 text-888 font-bold">데이터 전처리 정확도</p>
              </div>
              <div className="col-12 col-md-9 mt-3">
                <div className="row px-3">
                  <p className="font-bold mb-0 text-primary py-1 rounded-md break-words">
                    {preprocessInfo ? preprocessInfo.accuracy : ""}%
                  </p>
                </div>
              </div>
            </div>
            <div className="row flex items-center">
              <div className="col-12 col-md-3 mt-3">
                <p className="mb-0 text-888 font-bold">데이터 전처리 시간</p>
              </div>
              <div className="col-12 col-md-9 mt-3">
          
                {preprocessInfo.start ? (
                  <div className="row flex items-center">
                    <div className="col-12 col-sm-4 col-lg-3">
                      <p className="mb-0 text-999 font-bold whitespace-nowrap">시작 시각</p>
                    </div>
                    <div className="col-12 col-md-8 col-lg-9">
                      <div className="row px-3">
                        <p className="font-bold text-primary py-1 rounded-md mb-0">{preprocessInfo.start}</p>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {preprocessInfo.end ? (
                  <div className="row flex items-center">
                    <div className="col-12 col-sm-4 col-lg-3">
                      <p className="mb-0 text-999 font-bold whitespace-nowrap">끝 시각</p>
                    </div>
                    <div className="col-12 col-md-8 col-lg-9">
                      <div className="row px-3">
                        <p className="font-bold text-primary py-1 rounded-md mb-0">{preprocessInfo.end}</p>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="row flex items-center">
                  <div className="col-12 col-sm-4 col-lg-3">
                    <p className="mb-0 text-999 font-bold whitespace-nowrap">걸린 시간</p>
                  </div>
                  <div className="col-12 col-md-8 col-lg-9">
                    <div className="row px-3">
                      <p className="font-bold text-primary py-1 rounded-md mb-0">{preprocessInfo.time || ""}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-end">
              <button onClick={handleFileDownload}>
                <a className="text-xs" style={{ textDecoration: "underline" }}>
                  데이터 처리 결과 다운로드
                </a>
              </button>
            </div>
          </div>
        ) : (
          ""
        )} */}
      </div>
    </div>
  );
};

export default AlgorithmTab;
